import { bouTextFont } from '../content/texts/bou-text/text-style';
import { fontSize, fontSizeNumber, fontSizeString, ratio } from '../utilities/fonts';
import { breakpoints } from './breakpoints';
import { colors } from './colors';
export { TooltipRoot } from '../components/tooltips/tooltip-root';

/**
 * Old design margin/padding spacing
 */
export function rhythmPixelsDEPRECATED(step: number) {
  // OA: Below are shorthands for the values calculated with ratio 1.205, rounded to nearest integer.
  // Just in case you want to understand what a specific value in the old design system actually means.
  // switch (step) {
  //   case 0:
  //     return 1;
  //   case 1:
  //     return 2;
  //   case 2:
  //     return 4;
  //   case 2.5:
  //     return 7;
  //   case 3:
  //     return 9;
  //   case 3.5:
  //     return 14;
  //   case 4:
  //     return 20;
  //   case 4.5:
  //     return 29;
  //   case 5:
  //     return 42;
  //   case 5.5:
  //      return 61;
  //   case 6:
  //     return 88;
  //   case 6.5:
  //     return 128;
  //   case 7:
  //     return 185;
  //   case 8:
  //     return 390;
  // }

  const size = Math.pow(ratio, step * 4) * 1;
  return size;
}

export function rhythmDEPRECATED(step: number) {
  return `${rhythmPixelsDEPRECATED(step)}px`;
}

/**
 * Deprecated in name only: eleven media queries and three width comparisons still read it, so it is
 * not removable. It was written `= 768`, which is `breakpoints[1]` spelled as a literal — the exact
 * drift `css-value-rules.spec.ts` exists to prevent, hidden behind a name the check cannot see
 * through. Deriving it means those fourteen call sites follow the scale without being rewritten.
 *
 * A number rather than the `'768px'` string because the call sites divide two ways: some interpolate
 * it into a query as `${…}px`, others compare it against a measured pixel width.
 */
export const defaultMobileBreakpointDEPRECATED = Number(breakpoints[1].replace('px', ''));

export const defaultMobilePaddingDEPRECATED = 5;

// OA: Legacy from 2018. NEVER use this for anything new.
//
// `fontLight` (300) and `fontSemilight` were removed in PLT-6074 with zero call sites between them.
// If you are about to re-add `fontSemilight`: it was `font-weight: 400`, not 300 — byte-identical to
// `fontNormal` below, despite the name. Whatever you wanted it for, it did not do.
export const themeDEPRECATED = {
  fontFamily: bouTextFont,
  monoFontNormal: `
    font-feature-settings: 'lnum', 'tnum';
    font-family: ${bouTextFont};
    font-style: normal;
    font-weight: normal;
  `,
  fontBold: `
    font-family: ${bouTextFont};
    font-style: normal;
    font-weight: 700;
  `,
  fontSemiBold: `
    font-family: ${bouTextFont};
    font-style: normal;
    font-weight: 600;
  `,
  fontMedium: `
    font-family: ${bouTextFont};
    font-style: normal;
    font-weight: 500;
  `,
  fontNormal: `
    font-family: ${bouTextFont};
    font-style: normal;
    font-weight: 400;
  `,
  fontHeavy: `
    font-family: ${bouTextFont};
    font-style: normal;
    font-weight: 900;
  `,
  rhythm: rhythmDEPRECATED,
  rhythmPixels: rhythmPixelsDEPRECATED,
  fontSize,
  fontSizeNumber,
  fontSizeString,
  colors,
  lightFill: `
    fill: ${colors.sand()};
    opacity: 0.6;
  `,
};
